import React from 'react';
import MuiCard from '@mui/material/Card';
import MuiCardHeader from '@mui/material/CardHeader';
import MuiCardContent from '@mui/material/CardContent';
import MuiAvatar from '@mui/material/Avatar';
import MuiButton from '@mui/material/Button';
import MuiDivider from '@mui/material/Divider';
import MuiLink from '@mui/material/Link';
import MuiSelect from '@mui/material/Select';
import MuiMenuItem from '@mui/material/MenuItem';
import { Grid2 as MuiGrid } from '@mui/material';
import TextField from '@mui/material/TextField';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import MuiIconButton from '@mui/material/IconButton';
import Skeleton from '@mui/material/Skeleton';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import FormLabel from '@mui/material/FormLabel';

import {
  Menu as MenuIcon,
  Error as ErrorIcon,
  OpenInNew,
  ThumbUp,
  ThumbDown,
  Check,
  Cancel,
  ArrowBack,
  ArrowUpward,
} from '@mui/icons-material';

// Icon aliases matching @forge/common names
export const OpenInNewIcon = OpenInNew;
export const ThumbsUpIcon = ThumbUp;
export const ThumbsDownIcon = ThumbDown;
export const CheckIcon = Check;
export const CloseCircleIcon = Cancel;
export const ArrowLeftIcon = ArrowBack;
export const ArrowUpIcon = ArrowUpward;
export const Label = FormLabel;

export function ForgeIcon({ style, className, width = 24, height = 24 }) {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={style} className={className}>
      <circle cx="12" cy="12" r="12" fill="url(#paint0_linear_48418_3)"/>
      <path d="M18.3601 7.40484L12.8418 4.22145C12.5929 4.08304 12.3025 4 12.0259 4C11.7354 4 11.4588 4.0692 11.2099 4.22145L5.69157 7.40484C5.17985 7.6955 4.86176 8.22145 4.86176 8.80277V15.1972C4.86176 15.7785 5.16602 16.3045 5.66391 16.5952L11.1822 19.7785C11.4312 19.917 11.7216 20 11.9982 20C12.2886 20 12.5652 19.9308 12.8142 19.7785L18.3325 16.5952C18.8304 16.3045 19.1346 15.7647 19.1346 15.1972V8.80277C19.1761 8.22145 18.858 7.6955 18.3601 7.40484ZM18.3325 15.1972C18.3325 15.474 18.1803 15.737 17.9452 15.8754L12.4269 19.0588C12.3025 19.128 12.1642 19.1695 12.0259 19.1695C11.8876 19.1695 11.7493 19.128 11.6248 19.0588L6.10648 15.8754C5.87137 15.737 5.71923 15.474 5.71923 15.1972V8.80277C5.71923 8.52595 5.87137 8.26298 6.10648 8.12457L11.6248 4.94118C11.7493 4.87197 11.8876 4.83045 12.0259 4.83045C12.1642 4.83045 12.3025 4.87197 12.4269 4.94118L17.9452 8.12457C18.1803 8.26298 18.3325 8.52595 18.3325 8.80277V15.1972Z" fill="white"/>
      <path d="M16.7697 10.7682L12.1088 8.06926C12.0812 8.05542 12.0674 8.04158 12.0259 8.04158C11.9844 8.04158 11.9705 8.05542 11.9429 8.06926L7.26824 10.7682C7.24058 10.7821 7.22675 10.8097 7.22675 10.8236C7.22675 10.8513 7.24058 10.8651 7.26824 10.879L8.51296 11.5848C8.52679 11.5987 8.55445 11.5987 8.56829 11.5987C8.58212 11.5987 8.60978 11.5987 8.62361 11.5848L9.28746 11.1973C9.32895 11.1696 9.32895 11.1419 9.32895 11.1281C9.32895 11.1142 9.31512 11.0866 9.28746 11.0727L8.87255 10.8513C8.85872 10.8374 8.84489 10.8236 8.84489 10.8097C8.84489 10.7959 8.85872 10.7821 8.87255 10.7682L11.9014 9.02428C11.9429 8.9966 11.9705 8.98276 12.012 8.98276C12.0535 8.98276 12.1088 9.01044 12.1227 9.02428L15.11 10.7544C15.1239 10.7682 15.1377 10.7821 15.1377 10.7959C15.1377 10.8097 15.1239 10.8236 15.11 10.8374L12.0812 12.6506C12.0535 12.6644 12.0397 12.6644 12.0259 12.6644C11.9982 12.6644 11.9705 12.6506 11.9567 12.6367L11.5418 12.3876C11.528 12.3738 11.5141 12.3738 11.4865 12.3738C11.4588 12.3738 11.445 12.3738 11.4173 12.3876L10.7673 12.7751C10.7396 12.789 10.7258 12.8167 10.7258 12.8305C10.7258 12.8443 10.7258 12.872 10.7673 12.8997L11.9152 13.5918C11.9152 13.5918 11.9429 13.6194 11.9844 13.6194C12.0259 13.6194 12.0674 13.6056 12.0674 13.6056C12.261 13.4949 16.7282 10.9205 16.7558 10.9066C16.7835 10.8928 16.7835 10.8651 16.7835 10.8513C16.7973 10.7959 16.7835 10.7821 16.7697 10.7682Z" fill="white"/>
      <path d="M16.7697 13.1073L15.5111 12.4014C15.4973 12.3875 15.4696 12.3875 15.4558 12.3875C15.4419 12.3875 15.4143 12.3875 15.4005 12.4014L14.7366 12.7889C14.6951 12.8166 14.6951 12.8443 14.6951 12.8581C14.6951 12.872 14.7089 12.8996 14.7366 12.9135L15.1515 13.1349C15.1653 13.1488 15.1792 13.1626 15.1792 13.1765C15.1792 13.1903 15.1653 13.2041 15.1515 13.218L12.1503 14.9342L12.1227 14.9481C12.0812 14.9758 12.0535 14.9896 12.012 14.9896C11.9705 14.9896 11.9152 14.9619 11.9014 14.9481H11.8876L8.91404 13.218C8.90021 13.2041 8.88638 13.1903 8.88638 13.1765C8.88638 13.1626 8.90021 13.1488 8.91404 13.1349L11.9429 11.3495C11.9705 11.3356 11.9844 11.3356 11.9982 11.3356C12.0259 11.3356 12.0397 11.3495 12.0674 11.3633L12.4823 11.6124C12.4961 11.6263 12.5099 11.6263 12.5376 11.6263C12.5652 11.6263 12.5791 11.6263 12.6067 11.6124L13.2568 11.2249C13.2844 11.2111 13.2983 11.1834 13.2983 11.1695C13.2983 11.1557 13.2983 11.128 13.2568 11.1003L12.1088 10.4083C12.095 10.4083 12.0812 10.3806 12.0259 10.3806C11.9844 10.3806 11.9705 10.3945 11.9567 10.4083C11.9014 10.436 7.2959 13.0934 7.25441 13.1211C7.22675 13.1349 7.22675 13.1626 7.22675 13.1765C7.22675 13.2041 7.24058 13.218 7.25441 13.2318L11.9152 15.9308C11.9152 15.9308 11.9567 15.9585 11.9982 15.9585C12.0397 15.9585 12.0812 15.9308 12.0812 15.9308L16.7697 13.2318C16.7973 13.218 16.8111 13.1903 16.8111 13.1765C16.7973 13.1488 16.7835 13.1211 16.7697 13.1073Z" fill="white"/>
      <defs>
        <linearGradient id="paint0_linear_48418_3" x1="-8.5343e-08" y1="24" x2="24.6013" y2="23.0389" gradientUnits="userSpaceOnUse">
          <stop stopColor="#EE3124"/>
          <stop offset="1" stopColor="#EE4983"/>
        </linearGradient>
      </defs>
    </svg>
  );
}

export function Card({ children, className, style, ...rest }) {
  return (
    <MuiCard className={className} style={style} {...rest}>
      {children}
    </MuiCard>
  );
}

// Forge CardHeader: avatar, title, subtitle (→ subheader), label (unused), titleVariant (unused)
export function CardHeader({ avatar, className, subtitle, title, titleVariant, label, ...rest }) {
  return (
    <MuiCardHeader
      avatar={avatar}
      title={title}
      subheader={subtitle}
      className={className}
      {...rest}
    />
  );
}

// Forge CardContent: top prop controls padding — not replicated, just dropped
export function CardContent({ children, className, top, style, ...rest }) {
  return (
    <MuiCardContent className={className} style={style} {...rest}>
      {children}
    </MuiCardContent>
  );
}

// Forge Avatar: icon prop renders the icon at full size (no MUI circle behind it).
// text prop shows an initial letter inside a coloured circle.
export function Avatar({ icon, size = 'md', text, ...rest }) {
  const sizePx = { sm: 32, md: 40, lg: 56 }[size] || 40;
  if (icon) {
    return (
      <Box sx={{ width: sizePx, height: sizePx, flexShrink: 0 }} {...rest}>
        {React.cloneElement(icon, { width: sizePx, height: sizePx })}
      </Box>
    );
  }
  return (
    <MuiAvatar sx={{ width: sizePx, height: sizePx, bgcolor: '#E20000' }} {...rest}>
      {text}
    </MuiAvatar>
  );
}

const BUTTON_VARIANT_MAP = {
  primary: { variant: 'contained', color: 'inherit' },
  secondary: { variant: 'outlined', color: 'inherit' },
  'quiet-primary': { variant: 'text', color: 'inherit' },
  'quiet-secondary': { variant: 'text', color: 'inherit' },
  'destructive-secondary': { variant: 'outlined', color: 'error' },
};

const BUTTON_SX = {
  primary: {
    backgroundColor: '#E20000',
    color: '#fff',
    '&:hover': { backgroundColor: '#800000' },
  },
  secondary: {
    borderColor: '#330000',
    color: '#330000',
    '&:hover': { borderColor: '#800000', color: '#800000', backgroundColor: 'transparent' },
  },
  'secondary-fill': {
    backgroundColor: '#330000',
    color: '#fff',
    '&:hover': { backgroundColor: '#800000' },
  },
  'quiet-primary': {
    color: '#330000',
    '&:hover': { color: '#800000', backgroundColor: 'transparent' },
  },
  'quiet-secondary': {},
  'destructive-secondary': {},
};

// Forge Button: variant, icon, iconPosition, size, selected, children
// Icon-only buttons (no children) render the icon as the button content.
export function Button({
  variant = 'primary',
  icon,
  iconPosition = 'right',
  size = 'regular',
  selected,
  children,
  disabled,
  onClick,
  'aria-label': ariaLabel,
  style,
  ...rest
}) {
  const { variant: muiVariant, color: muiColor } = BUTTON_VARIANT_MAP[variant] || BUTTON_VARIANT_MAP.primary;
  const muiSize = size === 'large' ? 'large' : 'medium';

  let startIcon, endIcon, content;
  if (!children && icon) {
    content = icon;
  } else {
    startIcon = iconPosition === 'left' ? icon : undefined;
    endIcon = iconPosition !== 'left' && children ? icon : undefined;
    content = children;
  }

  return (
    <MuiButton
      variant={muiVariant}
      color={muiColor}
      size={muiSize}
      startIcon={startIcon}
      endIcon={endIcon}
      disabled={disabled}
      onClick={onClick}
      aria-label={ariaLabel}
      style={style}
      sx={{
        ...BUTTON_SX[variant],
        ...(selected ? { outline: '2px solid #330000', outlineOffset: '2px' } : {}),
      }}
      {...rest}
    >
      {content}
    </MuiButton>
  );
}

// Forge Header: logo, onMenuClick, rightSlot, showMenuToggle, centerSlot
// Breaks out of any parent Container using the 50vw negative-margin technique.
export function Header({ logo, onMenuClick, rightSlot, showMenuToggle, centerSlot }) {
  return (
    <AppBar
      position="static"
      elevation={0}
      sx={{
        backgroundColor: '#fff',
        color: 'inherit',
        width: '100vw',
        marginLeft: 'calc(-50vw + 50%)',
        marginRight: 'calc(-50vw + 50%)',
        position: 'relative',
        '&::after': {
          content: '""',
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          height: '3px',
          background: 'linear-gradient(to right, #d241d7, #e20001, #d241d7, #5947d1)',
        },
      }}
    >
      <Toolbar sx={{ justifyContent: 'space-between', minHeight: 64, px: { xs: 2, sm: 4 } }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {showMenuToggle && (
            <MuiIconButton
              edge="start"
              onClick={onMenuClick}
              aria-label="menu"
              sx={{ color: '#330000' }}
            >
              <MenuIcon />
            </MuiIconButton>
          )}
          {logo}
        </Box>
        {centerSlot && <Box sx={{ display: 'flex', alignItems: 'center' }}>{centerSlot}</Box>}
        {rightSlot && <Box sx={{ display: 'flex', alignItems: 'center' }}>{rightSlot}</Box>}
      </Toolbar>
    </AppBar>
  );
}

// Forge Divider: orientation, subtitle, subtitlePosition, type
export function Divider({ orientation = 'horizontal', subtitle, subtitlePosition = 'left', type, ...rest }) {
  return subtitle ? (
    <MuiDivider orientation={orientation} textAlign={subtitlePosition} {...rest}>
      {subtitle}
    </MuiDivider>
  ) : (
    <MuiDivider orientation={orientation} {...rest} />
  );
}

export function Link({ href, target, children, ...rest }) {
  return (
    <MuiLink
      href={href}
      target={target}
      rel={target === '_blank' ? 'noopener noreferrer' : undefined}
      {...rest}
    >
      {children}
    </MuiLink>
  );
}

// Forge Grid/Cell: maps to MUI Grid2 responsive layout
// cols and container (forge props) are dropped; colSpan/md/lg map to size breakpoints
export function Grid({ children, cols, container: containerType, spacing = 2, ...rest }) {
  return (
    <MuiGrid container spacing={spacing} {...rest}>
      {children}
    </MuiGrid>
  );
}

export function Cell({ children, colSpan, md, lg, ...rest }) {
  return (
    <MuiGrid
      size={{
        xs: colSpan || 12,
        md: md?.colSpan || colSpan || 12,
        lg: lg?.colSpan || colSpan || 12,
      }}
      {...rest}
    >
      {children}
    </MuiGrid>
  );
}

// Forge TextArea: size, color (forge props) are dropped; rest maps to MUI TextField
export function TextArea({ placeholder, rows = 3, color, size = 'regular', onChange, onKeyDown, value, disabled, ...rest }) {
  return (
    <TextField
      multiline
      fullWidth
      rows={rows}
      placeholder={placeholder}
      onChange={onChange}
      onKeyDown={onKeyDown}
      value={value}
      disabled={disabled}
      size={size === 'large' ? 'medium' : 'small'}
      {...rest}
    />
  );
}

// Forge Select: supports both controlled (value prop) and uncontrolled (defaultValue) modes
// height and size (forge props) are dropped
export function Select({ children, defaultValue = '', value: valueProp, placeholder, id, onChange, onBlur, onFocus, size, height, 'aria-label': ariaLabel, ...rest }) {
  const [internalValue, setInternalValue] = React.useState(defaultValue);
  const value = valueProp !== undefined ? valueProp : internalValue;

  const handleChange = (e) => {
    setInternalValue(e.target.value);
    if (onChange) onChange(e);
  };

  // MUI Select reads child.props.children for display, but SelectOption is a wrapper
  // so child.props.children is undefined. renderValue resolves label or children explicitly.
  const renderValue = (val) => {
    if (!val) {
      return <span style={{ color: 'rgba(0,0,0,0.42)' }}>{placeholder}</span>;
    }
    let display = String(val);
    React.Children.forEach(children, (child) => {
      if (React.isValidElement(child) && child.props.value === val) {
        display = child.props.label || child.props.children || String(val);
      }
    });
    return display;
  };

  return (
    <MuiSelect
      fullWidth
      value={value}
      onChange={handleChange}
      onBlur={onBlur}
      onFocus={onFocus}
      inputProps={{ id, 'aria-label': ariaLabel }}
      displayEmpty
      {...rest}
      renderValue={renderValue}
    >
      {placeholder && (
        <MuiMenuItem value="" disabled>
          {placeholder}
        </MuiMenuItem>
      )}
      {children}
    </MuiSelect>
  );
}

export function SelectOption({ label, value, children, ...rest }) {
  return <MuiMenuItem value={value} {...rest}>{children !== undefined ? children : label}</MuiMenuItem>;
}

// Forge SkeletonLoader: round → circular variant
export function SkeletonLoader({ round, width, height, ...rest }) {
  return (
    <Skeleton
      variant={round ? 'circular' : 'rectangular'}
      width={width || '100%'}
      height={height || 40}
      {...rest}
    />
  );
}

// Forge ControlError: inline error message with optional icon
export function ControlError({ children, showIcon, ...rest }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, color: 'error.main' }} {...rest}>
      {showIcon && <ErrorIcon fontSize="small" />}
      <Typography variant="body2" color="error">{children}</Typography>
    </Box>
  );
}
